<template>
  <div class="deposit" v-if="authjson.authjson(['3-2'])">
    <div class="d_top">{{ $t("main.text271") }}</div>
    <div class="d_top2" style="margin-bottom: 10px">
      {{ $t("main.text674") }}
    </div>
    <div class="d_top2">{{ $t("main.text792") }}</div>
    <div class="d_top2">{{ $t("main.text703") }}</div>
    <el-button class="body_row_btn" @click="open_deposit_dlg" size="medium">{{
      $t("main.text675")
    }}</el-button>

    <!-- 表格 -->
    <div class="transaction_h" v-if="authjson.authjson(['3-3'])">
      <div class="t_h1">
        <div class="t_h1_top">{{ $t("main.text322") }}</div>
        <div class="t_h1_box">
          <el-form
            class="zdy_form"
            label-position="top"
            label-width="300px"
            :model="form"
          >
            <el-form-item :label="$t('main.text323')" class="riqi_box">
              <el-date-picker
                popper-class="time_box"
                :clearable="false"
                :editable="false"
                v-model="form.t_h_time"
                type="daterange"
                :format="v_lan == 'en' ? 'dd/MM/yyyy' : 'yyyy/MM/dd'"
                value-format="yyyy-MM-dd"
                range-separator="-"
                :start-placeholder="$t('main.text324')"
                :end-placeholder="$t('main.text325')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('main.text326')">
              <el-input v-model="form.t_h_id" placeholder=""></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text334')">
              <el-select
                v-model="form.t_h_type"
                :placeholder="$t('main.text328')"
              >
                <el-option label="USD" value="USD"></el-option>
                <el-option label="SGD" value="SGD"></el-option>
                <el-option label="CNY" value="CNY"></el-option>
                <el-option label="GBP" value="GBP"></el-option>
                <el-option label="AUD" value="AUD"></el-option>
                <el-option label="HKD" value="HKD"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form>
            <el-form-item class="btn_box">
              <el-button
                class="reset_btn border_set_color"
                size="medium"
                @click="reset_btn"
                >{{ $t("main.text329") }}</el-button
              >
              <el-button class="apply_btn" size="medium" @click="apply_btn">{{
                $t("main.text330")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="t_h2">
        <div class="t_h2_box">
          <div>
            <div class="t_h2_txt1">{{ $t("main.text270") }}</div>
            <!-- <div class="t_h2_txt2">{{$t('main.text332')}}</div> -->
          </div>
          <div>
            <el-button v-if="authjson.authjson(['3-4'])"
              class="export_btn border_set_color2"
              icon="el-icon-download"
              size="medium"
              @click="download_btn"
              >{{ $t("main.text333") }}</el-button
            >
          </div>
        </div>
        <div class="t_h2_table zdy_tab_header">
          <el-table
            :data="tableData"
            stripe
            :cell-style="cellStyle"
            style="width: 100%"
          >
            <el-table-column :label="$t('main.text99')" min-width="120">
              <span slot-scope="props">
                {{ overall_time(props.row.c_time) }}
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text751')" min-width="260">
              <span slot-scope="props">
                <span v-html="props.row.type_name"></span>
                <!-- type 3,4,5,6,7,8,12 卡号 -->
                <!-- type 2,10,11 显示name -->
                <!-- type 1,9,13 remark -->
                <div v-if="[3, 4, 5, 6, 7, 8, 12].includes(props.row.type)">
                  <p>{{ $t("main.text767") }} {{ props.row.card_number }}</p>
                </div>
                <div v-else-if="[2, 10, 11].includes(props.row.type)">
                  {{ props.row.name }}
                </div>
                <div>
                  {{ props.row.remark }}
                </div>
              </span>
            </el-table-column>

            <el-table-column prop="tx_id" :label="$t('main.text326')" min-width="120">
            </el-table-column>

            <el-table-column :label="$t('main.text770')" min-width="120">
              <span slot-scope="props">
                <span>
                  {{ set_num3_2(props.row.amount) }}
                </span>
              </span>
            </el-table-column>

            <el-table-column :label="$t('main.text316')" min-width="120">
              <span slot-scope="props">
                <!-- 状态: 20 成功 21 审核中 22 审核失败; 23交易中；24交易失败 25 待审核 -->
                <span v-if="props.row.status == 20">{{
                  $t("main.text317")
                }}</span>
                <span v-else-if="props.row.status == 21">{{
                  $t("main.text318")
                }}</span>
                <span v-else-if="props.row.status == 22">{{
                  $t("main.text319")
                }}</span>
                <span v-else-if="props.row.status == 23">{{
                  $t("main.text320")
                }}</span>
                <span v-else-if="props.row.status == 24">{{
                  $t("main.text321")
                }}</span>
                <span v-else-if="props.row.status == 25">{{
                  $t("main.text229")
                }}</span>
                <span v-else>-</span>
              </span>
            </el-table-column>

            <el-table-column width="80">
              <span slot-scope="props">
                <img
                  @click="to_info(props.row.tx_id, props.row.id)"
                  class="icon_width"
                  src="../../../assets/img/info_icon.png"
                  alt=""
                />
              </span>
            </el-table-column>
          </el-table>

          <el-pagination
            v-if="tableData.length > 0"
            background
            :page-sizes="[10, 20, 30, 40]"
            :page-size="limit"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="page_total"
            @current-change="current_change"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- over -->

    <!--  Deposit 填信息 4个输入框  弹框 -->
    <el-dialog
      :title="$t('main.text480')"
      :visible.sync="deposit_dlg"
      custom-class="dlg element_input add_dlg inp_dab"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="form_tit">{{ $t("main.text676") }}</div>
            <el-form-item :label="$t('main.text682')">
              <el-select
                v-model="deposit.currency"
                filterable
                @change="inp_amount"
                :placeholder="$t('main.text135')"
              >
                <el-option
                  v-for="(item, index) in currency_list"
                  :key="index"
                  :label="
                    v_lan == 'ch'
                      ? item.currency + ' (' + item.ch_name + ')'
                      : v_lan == 'jp'
                      ? item.currency + ' (' + item.jp_name + ')'
                      : item.currency + ' (' + item.en_neme + ')'
                  "
                  :value="item.currency"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('main.text314')">
              <el-input
                v-model="deposit.amount"
                @input="inp_amount"
                oninput="value=value.replace(/[^0-9.]/g,'')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text680')">
              <el-input v-model="deposit.from_bank"></el-input>
            </el-form-item>

            <el-form-item :label="$t('main.text773')">
              <el-input v-model="deposit.sender_account_name"></el-input>
            </el-form-item>

            <el-form-item :label="$t('main.text681')">
              <el-select
                v-model="deposit.from_countries"
                filterable
                @change="phone_code_change"
                :placeholder="$t('main.text135')"
              >
                <div v-for="(item, name) in code_json" :key="name">
                  <el-option
                    v-for="(item, index) in item"
                    :key="index"
                    :label="item.name + ' + ' + item.num"
                    :value="[item.name, item.num]"
                  >
                  </el-option>
                </div>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('main.text713')" v-if="!selest_dab">
              <!-- <el-select v-model="deposit.select_num" filterable :disabled="selest_dab" :placeholder="$t('main.text135')" @change="select_change"> -->
              <el-select
                v-model="deposit.select_num"
                filterable
                :placeholder="$t('main.text135')"
                @change="select_change"
              >
                <el-option :label="$t('main.text714')" value="1"></el-option>
                <el-option :label="$t('main.text715')" value="2"></el-option>
                <el-option :label="$t('main.text716')" value="3"></el-option>
                <el-option :label="$t('main.text717')" value="4"></el-option>
                <el-option :label="$t('main.text718')" value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('main.text791')"
              v-if="deposit.select_num == '5'"
            >
              <el-input v-model="deposit.other_text"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="deposit_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button type="primary" @click="deposit_confirm" class="confirm_btn">
          {{ $t("main.text36") }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 填信息 成功 弹框 -->
    <el-dialog
      :visible.sync="deposit_ok_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px"
    >
      <div class="log_out1">
        <img
          style="width: 35px"
          src="../../../assets/img/Pigeon_icon.png"
          alt=""
        />
      </div>
      <div class="log_out2 padding1">
        {{ $t("main.text677") }}
      </div>
      <div class="log_out3 padding2">
        {{ $t("main.text678") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="confirm_btn2"
          @click="deposit_ok_dlg = false"
          >{{ $t("main.text266") }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 是否跳转链接 弹框 -->
    <el-dialog
      :visible.sync="jump_link_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="640px"
    >
      <div class="jump_link_text">
        {{ $t("main.text721") }}
      </div>
      <div class="jump_link_text">
        {{ $t("main.text722") }}
        <span v-if="v_lan != 'ch'">{{ deposit.currency }}</span>
        {{ $t("main.text723") }}
      </div>
      <div class="jump_link_text">
        {{ $t("main.text724") }}
      </div>
      <div class="jump_link_text">
        {{ $t("main.text725") }}
        <span v-if="v_lan != 'ch'">{{ deposit.currency }}</span>
        {{ $t("main.text726") }}
      </div>
      <div class="jump_link_text">
        {{ $t("main.text727") }}
        {{ deposit.currency }}
        {{ $t("main.text728") }}
      </div>
      <div class="jump_link_text">
        {{ $t("main.text729") }}
      </div>
      <div class="jump_link_text">
        {{ $t("main.text730") }}
      </div>
      <div class="jump_link_text">
        {{ $t("main.text731") }}
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="jump_link_dlg = false"
          class="cancel_btn border_set_color2"
        >
          {{ $t("main.text7") }}
        </el-button>
        <el-button type="primary" class="ok_btn" @click="ob_btn_fun">
          {{ $t("main.text11") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { details, deposit_submit, deposit_getConfig } from "@/api/api";
import { record, deposit_download } from "@/api/api";
import QRCode from "qrcodejs2";
import BigNumber from "bignumber.js";

export default {
  data() {
    return {
      qrcode_addr1: "111",
      qrcode_addr2: "111",
      qrcode_addr3: "111",
      qrcode_addr4: "111",
      qrcode_addr5: "111",
      qrcode_addr6: "111",
      // ewm_addr:'a--b'+'\r\n'+'c--d',
      bank_info: {},
      wallet_info: {},

      ewn_fd_dlg: false,
      deposit_code: "",
      ewm_fd_title: "",

      btc: {},
      eth: {},
      usdc: {},
      usdt: {},

      deposit_dlg: false,
      deposit_ok_dlg: false,
      deposit: {
        currency: "",
        amount: "",
        from_bank: "",
        sender_account_name: "",
        from_countries: "",
        from_country_code: "",
        select_num: "",
        other_text: "",
      },
      code_json: "",
      FirstPin: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      kyc_status: "",
      // currency_list: require("@/assets/phone_code/currency_data.json"),
      currency_list: [{
        "currency": "USD",
        "jp_name": "米ドル",
        "en_neme": "United States Dollar",
        "ch_name": "美国"
      }],
      selest_dab: true,
      fixedRate: "",
      rateConfig: "",
      usdLimit: "",
      jump_link_dlg: false,
      payUrl: "",

      // 表格
      form: {
        t_h_time: "",
        t_h_id: "",
        t_h_type: "",
      },
      currentPage: 1, //选中的页数
      page: 1, //分页 从 1 开始
      limit: 10, //每页条数
      page_total: 0, //一共多少条
      tableData: [],
      // ----
    };
  },
  created() {
    if (this.v_lan == "ch") {
      this.code_json = require("@/assets/phone_code/num_area_ch2.json");
    } else {
      this.code_json = require("@/assets/phone_code/num_area_en2.json");
    }
    if (this.code_json) {
      let cityName = {};
      //循环26个字母的数组
      this.FirstPin.forEach((item) => {
        cityName[item] = [];
        this.code_json.forEach((el) => {
          //对比开头字母是否对应
          // 做一个判断 中文时候不走
          let first = el.py.substring(0, 1).toUpperCase();
          if (first == item) {
            cityName[item].push(el);
          }
        });
      });
      // console.log(cityName)
      this.$nextTick(() => {
        this.code_json = cityName;
        // console.log(this.code_json);
      });
    }
  },
  mounted() {
    sessionStorage.setItem("top_title_name", this.$t("main.text14"));
    // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
    this.kyc_status = sessionStorage.getItem("kyc_status");
    this.get_list();
    this.get_list_table();
    // this.qrcodeRender(this.qrcode_addr1,this.qrcode_addr2,this.qrcode_addr3,this.qrcode_addr4,this.qrcode_addr5,this.qrcode_addr6);
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  methods: {
    get_list() {
      details().then((res) => {
        if (res.data.code == 200) {
          //    console.log(res.data.data);
          this.deposit_code = res.data.data.deposit_code;
          if (res.data.data.bank_info) {
            this.bank_info = res.data.data.bank_info;
            //    console.log(res.data.data.bank_info);
          }
          if (res.data.data.wallet_info) {
            this.wallet_info = res.data.data.wallet_info;
            //    console.log(res.data.data.wallet_info);

            this.btc = res.data.data.wallet_info.btc;
            this.eth = res.data.data.wallet_info.eth;
            this.usdc = res.data.data.wallet_info.usdc;
            this.usdt = res.data.data.wallet_info.usdt;

            this.qrcode_addr1 = res.data.data.wallet_info.usdt.address;
            this.qrcode_addr2 = res.data.data.wallet_info.usdt.trc_address;
            // this.qrcode_addr3=res.data.data.wallet_info.btc.address;
            this.qrcode_addr4 = res.data.data.wallet_info.usdc.address;
            this.qrcode_addr5 = res.data.data.wallet_info.usdc.trc_address;
            // this.qrcode_addr6=res.data.data.wallet_info.eth.address;

            //    setTimeout(() => {
            //     //    this.qrcodeRender(this.qrcode_addr1,this.qrcode_addr2,this.qrcode_addr3,this.qrcode_addr4,this.qrcode_addr5,this.qrcode_addr6);
            //        this.qrcodeRender(this.qrcode_addr1,this.qrcode_addr2,this.qrcode_addr4,this.qrcode_addr5);
            //    }, 100);
          }
        }
      });
    },
    ewm_fd(v, tit) {
      this.ewm_fd_title = tit;
      setTimeout(() => {
        if (this.ewn_fd_dlg) {
          this.$refs.qrcode_fd.innerHTML = "";
          new QRCode(this.$refs.qrcode_fd, {
            width: 240,
            height: 240,
            text: v, // 二维码内容
            colorDark: "#fff",
            colorLight: "transparent",
            correctLevel: QRCode.CorrectLevel.H,
          });
        }
      }, 100);
      this.ewn_fd_dlg = true;
    },
    // qrcodeRender(v1,v2,v3,v4,v5,v6) {
    qrcodeRender(v1, v2, v3, v4) {
      // 1
      this.$refs.qrcode1.innerHTML = "";
      new QRCode(this.$refs.qrcode1, {
        width: 78,
        height: 78,
        // width: 170,
        // height: 170,
        text: v1, // 二维码内容
        colorDark: "#fff",
        colorLight: "transparent",
        correctLevel: QRCode.CorrectLevel.H,
      });
      // 2
      this.$refs.qrcode2.innerHTML = "";
      new QRCode(this.$refs.qrcode2, {
        width: 78,
        height: 78,
        text: v2, // 二维码内容
        colorDark: "#fff",
        colorLight: "transparent",
        correctLevel: QRCode.CorrectLevel.H,
      });
      // 3
      // this.$refs.qrcode3.innerHTML = "";
      // new QRCode(this.$refs.qrcode3, {
      //     width: 78,
      //     height: 78,
      //     text: v3, // 二维码内容
      //     colorDark: "#fff",
      //     colorLight: "transparent",
      //     correctLevel: QRCode.CorrectLevel.H,
      // });
      // 4
      this.$refs.qrcode4.innerHTML = "";
      new QRCode(this.$refs.qrcode4, {
        width: 78,
        height: 78,
        text: v3, // 二维码内容
        colorDark: "#fff",
        colorLight: "transparent",
        correctLevel: QRCode.CorrectLevel.H,
      });
      // 5
      this.$refs.qrcode5.innerHTML = "";
      new QRCode(this.$refs.qrcode5, {
        width: 78,
        height: 78,
        text: v4, // 二维码内容
        colorDark: "#fff",
        colorLight: "transparent",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    //复制
    copy_api(v) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", v);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      document.body.removeChild(input);
      this.message.ismessage("success", this.$t("main.text297"));
      // this.$message.success("复制成功");
    },

    Copy() {
      return new Promise((resolve) => {
        let copy_string =
          this.$t("main.text298") +
          this.bank_info.bank_name +
          "\r\n" +
          this.$t("main.text299") +
          this.bank_info.bank_address +
          "\r\n" +
          this.$t("main.text300") +
          this.bank_info.bank_code +
          "\r\n" +
          this.$t("main.text301") +
          this.bank_info.branch_name +
          "\r\n" +
          this.$t("main.text302") +
          this.bank_info.bank_acc_number +
          "\r\n" +
          this.$t("main.text303") +
          this.bank_info.bank_account_name +
          "\r\n" +
          this.$t("main.text304") +
          this.bank_info.country +
          "\r\n" +
          this.$t("main.text305") +
          this.bank_info.currency +
          "\r\n" +
          this.$t("main.text306") +
          this.bank_info.swift_code +
          "\r\n" +
          this.$t("main.text307") +
          this.bank_info.company_address +
          "\r\n" +
          this.$t("main.text308") +
          this.bank_info.reference;

        const copyUrl = document.createElement("textarea"); //创建一个textarea框获取需要复制的文本内容
        copyUrl.value = copy_string;
        const appDiv = document.getElementById("app");
        appDiv.appendChild(copyUrl);
        copyUrl.select();
        document.execCommand("Copy");
        copyUrl.remove();
        resolve(true);
        this.message.ismessage("success", this.$t("main.text297"));
      });
    },
    open_deposit_dlg() {
      // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
      if (this.kyc_status && this.kyc_status != 4) {
        return this.message.ismessage("error", this.$t("main.text599"));
      }
      this.deposit.currency = "";
      this.deposit.amount = "";
      this.deposit.from_bank = "";
      this.deposit.sender_account_name = "";
      this.deposit.from_countries = "";
      this.deposit.from_country_code = "";

      this.deposit.select_num = "";
      this.deposit.other_text = "";
      this.selest_dab = true;
      deposit_getConfig().then((res) => {
        if (res.data.code == 200) {
          this.fixedRate = res.data.data.fixedRate;
          this.rateConfig = res.data.data.rateConfig;
          this.usdLimit = res.data.data.usdLimit;
          this.deposit_dlg = true;
          this.deposit.currency = this.currency_list[0].currency;
          this.inp_amount(this.deposit.currency);
          // console.log(res.data.data);
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    deposit_confirm() {
      if (!this.deposit.currency)
        return this.message.ismessage("error", this.$t("main.text683"));
      if (!this.deposit.amount.trim())
        return this.message.ismessage("error", this.$t("main.text684"));
      if (!this.deposit.from_bank.trim())
        return this.message.ismessage("error", this.$t("main.text685"));
      if (!this.deposit.sender_account_name.trim())
        return this.message.ismessage("error", this.$t("main.text774"));
      if (!this.deposit.from_countries)
        return this.message.ismessage("error", this.$t("main.text686"));
      if (!this.deposit.from_country_code)
        return this.message.ismessage("error", this.$t("main.text686"));
      if (!this.selest_dab && this.deposit.select_num == "") {
        return this.message.ismessage("error", this.$t("main.text107"));
      }
      if (
        !this.selest_dab &&
        this.deposit.select_num == "5" &&
        !this.deposit.other_text
      ) {
        return this.message.ismessage("error", this.$t("main.text107"));
      }
      let inp_declaration = "";
      if (this.deposit.select_num == "1") {
        inp_declaration = "Sale of property";
      } else if (this.deposit.select_num == "2") {
        inp_declaration = "Business proceeds";
      } else if (this.deposit.select_num == "3") {
        inp_declaration = "Profits from business operations";
      } else if (this.deposit.select_num == "4") {
        inp_declaration = "Trading";
      } else if (this.deposit.select_num == "5") {
        inp_declaration = this.deposit.other_text;
      }
      // console.log(this.deposit);
      // console.log(inp_declaration);
      deposit_submit({
        currency: this.deposit.currency,
        amount: this.deposit.amount,
        from_bank: this.deposit.from_bank,
        sender_account_name: this.deposit.sender_account_name,
        from_country: this.deposit.from_countries,
        from_country_code: this.deposit.from_country_code,
        declaration: inp_declaration,
      }).then((res) => {
        if (res.data.code == 200) {
          this.deposit_dlg = false;
          // "show_type": 1银行信息 0不展示;2跳转链接
          // "payUrl": "", //show_type为2的时候跳转的链接
          if (res.data.data.show_type == 0) {
            this.deposit_ok_dlg = true;
          } else if (res.data.data.show_type == 1) {
            // console.log(res.data.data.bank_info);
            sessionStorage.setItem("bank_info_data", res.data.data.bank_info);
            this.$router.push({ path: "/blockchain_d/bank_details" });
          } else if (res.data.data.show_type == 2) {
            this.payUrl = res.data.data.payUrl;
            this.jump_link_dlg = true;
          }
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    phone_code_change(v) {
      // console.log(v);
      if (v.length) {
        this.deposit.from_countries = v[0];
        this.deposit.from_country_code = v[1];
      }
    },
    inp_amount(v) {
      // console.log(this.deposit.currency);
      // console.log(v);
      v;
      // if(this.deposit.currency=='USD'&& this.deposit.amount>=9900){
      // toFixed(2,0) 我们是1向下0向上
      if (
        this.deposit.currency == "USD" &&
        BigNumber(this.deposit.amount).gte(this.usdLimit)
      ) {
        this.selest_dab = false;
      } else if (
        ["SGD", "CNY", "GBP", "AUD", "HKD"].includes(this.deposit.currency)
      ) {
        let fiatRate = this.rateConfig["USDT" + this.deposit.currency];
        let usdRate = this.rateConfig["USDTUSD"];
        let rateValue = BigNumber(this.deposit.amount)
          .div(fiatRate)
          .times(usdRate)
          .times(this.fixedRate)
          .toFixed(2, 1);
        if (BigNumber(rateValue).gte(this.usdLimit)) {
          this.selest_dab = false;
        } else {
          this.selest_dab = true;

          this.deposit.select_num = "";
          this.deposit.other_text = "";
        }
      } else {
        this.selest_dab = true;

        this.deposit.select_num = "";
        this.deposit.other_text = "";
      }
    },
    select_change(v) {
      // console.log(v);
      v;
      if (this.deposit.select_num != "5") {
        this.deposit.other_text = "";
      }
    },
    ob_btn_fun() {
      window.open(this.payUrl, "_blank");
      this.jump_link_dlg = false;
    },

    // 表格
    // ----
    reset_btn() {
      this.form.t_h_time = "";
      this.form.t_h_id = "";
      this.form.t_h_type = "";
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list_table();
    },
    apply_btn() {
      // console.log(this.form);
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list_table();
    },
    get_list_table() {
      record({
        page: this.page,
        limit: this.limit,
        start_date: this.form.t_h_time ? this.form.t_h_time[0] : "",
        end_date: this.form.t_h_time ? this.form.t_h_time[1] : "",
        hash_tx_id: this.form.t_h_id,
        account_type: 2,
        token_type: this.form.t_h_type,
      }).then((res) => {
        if (res.data.code == 200) {
          // console.log(res.data.data);
          this.page_total = res.data.data.count;
          this.tableData = res.data.data.list;
        }
      });
    },
    cellStyle({ row }) {
      // tx_type: 1加密货币 2法币 法币 那行为绿色文字
      if (row.tx_type == 2) {
        // return 'color:#12BA9C';
        return "";
      } else {
        return "";
      }
    },
    current_change(v) {
      // console.log(v);
      this.page = v;
      this.limit = 10;
      this.get_list_table();
    },
    to_info(hash_tx_id, id) {
      sessionStorage.setItem("info_hash_tx_id", hash_tx_id);
      sessionStorage.setItem("info_id", id);
      setTimeout(() => {
        this.$router.push("/blockchain_d/transaction_h_info");
      }, 100);
    },
    download_btn() {
      if (this.page_total <= 0) {
        return this.message.ismessage("error", this.$t("main.text335"));
      }
      deposit_download({
        start_date: this.form.t_h_time ? this.form.t_h_time[0] : "",
        end_date: this.form.t_h_time ? this.form.t_h_time[1] : "",
        hash_tx_id: this.form.t_h_id,
        account_type: 2,
        token_type: this.form.t_h_type,
      }).then((res) => {
        const filename =
          res.headers["content-disposition"].split(";")[1].split("=")[1] ||
          "download.xlsx";
        const link = document.createElement("a");
        const blob = new Blob([res.data], { type: "application/octet-stream" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${filename}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
};
</script>

<style scoped>
.d_top {
  margin-top: 46px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
}
.d_top2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.8;
  margin-bottom: 20px;
}
.d_box {
  background: #314b69;
  border-radius: 16px;
  overflow: hidden;
}
.d_box_top {
  box-sizing: border-box;
  padding: 20px 28px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  border-bottom: 1.5px solid #041e35;
}
.d_box_body {
  box-sizing: border-box;
  padding: 28px;
}
.alert_box {
  min-height: 64px;
}
/* .alert_style{
    min-height: 64px;
    background: #E8DAC8;
    border-radius: 4px;
}
.alert_style >>> .el-alert__icon{
    color: #B28247;
    font-size: 20px;
    width: 40px;
}
.alert_text{
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    color: #B28247;
}
.alert_num{
    font-weight: 700;
    color: #314B69;
} */
.body_row {
  display: flex;
  margin-top: 28px;
  justify-content: space-between;
}
.body_row > div {
  width: 31%;
}
.body_row_t1 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  opacity: 0.6;
}
.body_row_t2 {
  margin-top: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
}
.body_row_btn,
.body_row_btn:hover {
  min-width: 200px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #deb981;
  background: transparent;
  border-style: solid;
  border-width: 1.5px;
  border-color: #ecbd75 #e3a84e #ecbc74 #f1c788;
}
.body2_top {
  /* margin-top: 80px; */
  margin-top: 40px;
}
.wenhao {
  margin-left: 6.5px;
  cursor: pointer;
  font-size: 14px;
  color: #9ba5ae;
}
.body2_main {
  background: #314b69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
}
.b2_main1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;
}
.body2_main .b2_main1:last-child {
  margin-bottom: 0;
}
.b2_main1 > div {
  width: 32%;
}
.ewm_box1 {
  background: #50af95;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 20px;
}
.ewm_box2 {
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.3); */
  display: flex;
  /* padding-bottom: 20px; */
  padding-bottom: 12px;
  align-items: center;
  justify-content: space-between;
}
.ewm_box3 {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #26443c;
  margin-bottom: 4px;
}
.ewm_box4 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #26443c;
  opacity: 0.8;
  margin-bottom: 12px;
}
.ewm_box5 {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
  margin-bottom: 4px;
}
.ewm_box6 {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #ffffff;
  opacity: 0.8;
}
.ewm_box7 {
  margin-right: 20px;
  width: 78px;
  height: 78px;
  cursor: pointer;
}
.ewm_btm_2 {
  margin: 20px 0 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  opacity: 0.8;
}
.ewm_btm_3 {
  display: flex;
  justify-content: space-between;
}
.ewm_btm_4 {
  width: 63%;
  height: 36px;
  line-height: 36px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 8px;
}
.ewm_btm_5 {
  /* width: 30%; */
  height: 36px;
  line-height: 36px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
  border: 1.5px solid rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 8px;
  cursor: pointer;
  text-align: center;
}
.copy_icon {
  width: 17px;
  vertical-align: middle;
  margin-right: 7px;
}
.ewm_box2_bgc {
  background: #2775ca;
}
.ewm_box3_bgc {
  background: #908279;
}
.ewm_box4_bgc {
  background: #ea815f;
}
.ewm_box5_bgc {
  background: #66a9ba;
}
.ewm_box6_bgc {
  background: #5d7289;
}
.ewm_fd_box {
  text-align: center;
}
.ewm_fd_box2 {
  display: inline-block;
}
.ewm_fd_title {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 15px;
  color: #fff;
}
.b2_main1 .ewm_box1_width {
  /* width: 65%; */
  width: 100%;
}
.ewm_box2_1 {
  width: 46%;
  display: flex;
  align-items: center;
}
.ewm_btm_box {
  display: flex;
  justify-content: space-between;
}
.ewm_btm_box_1 {
  width: 46%;
}
.ewm_box2_left {
  justify-content: start;
}
.ewm_box3_t1 {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
  margin-bottom: 4px;
}
.ewm_box3_t2 {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #ffffff;
  opacity: 0.8;
}
.ewm_box_new {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.form_tit {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  margin-bottom: 20px;
  word-break: break-word;
}
.ok_btn,
.ok_btn:hover,
.ok_btn:focus,
.ok_btn:active {
  min-width: 86px;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgb(222 185 129 / 20%);
  border-radius: 4px;
  border-color: #f1c788;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  color: #04182a;
  /* margin-bottom: 15px; */
  margin-left: 20px !important;
}
.jump_link_text {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  color: #ffffff;
  margin-top: 16px;
  /* text-align: center; */
  word-break: break-word;
  word-wrap: break-word;
  opacity: 0.8;
}
</style>

<style scoped>
/* 表格css */
.t_h1_top {
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box {
  background: #314b69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item {
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select {
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child {
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: inherit;
}
.zdy_form >>> .el-input__inner {
  background: #223c58;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
  color: #deb981;
  /* border-style:solid; */
  /* border-width: 1.5px; */
  /* border-color:#ECBD75 #E3A84E #ECBC74 #F1C788; */
  /* background: transparent; */
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
}

.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
  min-width: 120px;
  border-color: #f1c788;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182a;
}
.zdy_form .btn_box {
  width: auto;
}
.t_h2_box {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.t_h2_txt1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
}
.t_h2_txt2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
  color: #deb981;
  border-style: solid;
  border-width: 1.5px;
  border-color: #ecbd75 #e3a84e #ecbc74 #f1c788;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  min-width: 120px;
  background: transparent;
}
.icon_width {
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
</style>


<style scoped>
/* 手机端 */
@media screen and (max-width: 850px) {
  .b2_main1 {
    flex-direction: column;
  }
  .b2_main1 > div {
    width: 100% !important;
  }
  .ewm_box3_bgc,
  .ewm_box4_bgc {
    margin-top: 25px;
  }
  .ewm_box7 {
    margin-right: 7px;
  }
  .ewm_btm_5,
  .ewm_box3 {
    font-size: 12px !important;
    min-width: 75px;
    padding-left: 4px;
    padding-right: 4px;
  }
  .copy_icon {
    width: 14px;
    margin-right: 3px;
  }
  .body2_main {
    background: transparent !important;
    padding: 0 !important;
  }
  .body2_top {
    margin-top: 20px;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .d_top2 {
    font-size: 13px;
    margin-bottom: 20px;
  }
}
</style>

<style>
.top_user2 {
  color: rgba(255, 255, 255, 0.6) !important;
}

.inp_dab .el-input.is-disabled .el-input__inner {
  background-color: #51637a !important;
  border-color: #51637a !important;
  color: #c0c4cc !important;
  cursor: not-allowed !important;
}
</style>